import { render, staticRenderFns } from "./aiContent.vue?vue&type=template&id=24eda345&scoped=true"
import script from "./aiContent.vue?vue&type=script&lang=js"
export * from "./aiContent.vue?vue&type=script&lang=js"
import style0 from "./aiContent.vue?vue&type=style&index=0&id=24eda345&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eda345",
  null
  
)

export default component.exports